import * as types from '../mutations-types'

// STATES
const state = {
  notificationsList: [],
  notificationData: '',
  showNotification: false
}

// GETTERS
const getters = {
  notificationsList: state => state.notificationsList,
  notificationData: state => state.notificationData,
  showNotification: state => state.showNotification
}

// ACTIONS
const actions = {
  setNextNotification({commit}) {
    commit(types.SET_NEXT_NOTIFICATION)
  },
  spliceNotificationsList({commit}) {
    commit(types.SPLICE_NOTIFICATION_LIST)
  },
  closeNotification({commit}) {
    commit(types.SHOW_NOTIFICATION, false)
    // commit(types.SET_NOTIFICATION, '')
  },
  setNotificationText({commit}, data) {
    // const fullMessage = data.messageText + '\n' + data.data.fileName + '\n' + data.data.plate + '\n' + data.data.fromDate + '\n' + data.data.toDate
    const fullMessage = {
      error: data.data.error,
      url: data.data.url,
      messageText: data.messageText,
      fileName: data.data.fileName,
      plate: data.data.plate,
      fromDate: data.data.fromDate,
      toDate: data.data.toDate
    }
    commit(types.SET_NOTIFICATION, fullMessage)
  },
  notifyNewReportByRouteTime({commit, dispatch}, data) {
    dispatch('setNotificationText', data)
    commit(types.SHOW_NOTIFICATION, true)
  }
}

// MUTATIONS
const mutations = {
  [types.SET_NEXT_NOTIFICATION](state) {
    state.notificationData = state.notificationsList[0]
  },
  [types.SPLICE_NOTIFICATION_LIST](state) {
    state.notificationsList.splice(0, 1)
  },
  [types.SET_NOTIFICATION](state, data) {
    state.notificationsList.push(data)
    state.notificationData = state.notificationsList[0]
  },
  [types.SHOW_NOTIFICATION](state, value) {
    state.showNotification = value
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/notifications.js